export enum ComponentSurfaceWrappingMode {
  ComponentWrapsX,
  ComponentWrapsY,
  ComponentNoWrap,
  UnrolledComponentWrapsX, // component wraps x but is in 2D mode
  UnrolledComponentWrapsY, // component wraps y but is in 2D mode
}
